import React, { useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";
import { ProgressBar } from "react-bootstrap";
import refreshIcon from "../../assets/img/img-refresh.svg";
import LoadingOverlay from "react-loading-overlay";
import Loader from "./components/Loader";
import "./ProgressBarModal.css";
import TaskManagerModal from "../taskManager/components/TaskManagerModal";
import { checkPermission } from "../../config/utils";
import moment from "moment";
import "./ProgressBarModal.css";

const ProgressBarModal = ({ onClose, data = {}, refresh, refreshTableData, taskId }) => {
    const [initialLoading, setInitialLoading] = useState(true);
    const [progressData, setProgressData] = useState(data ?? {});
    const [showTaskManager, setShowTaskManager] = useState(false);
    const prevDataRef = useRef(null);
    const canSeeTaskManager = checkPermission("menu", "settings", "task-manager");
    const progressStatus = {
        0: { value: "PENDING", color: "#8193A9" },
        1: { value: "QUEUED", color: "#006EFF" },
        2: { value: "IN PROGRESS", color: "#006EFF" },
        3: { value: "COMPLETED", color: "#04B934" },
        4: { value: "FAILED", color: "#e61607" },
        5: { value: "CANCELLED", color: "#e61607" }
    };

    useEffect(() => {
        refresh();
    }, []);

    useEffect(() => {
        if (data?.success) {
            setInitialLoading(false);
            setProgressData(data?.data ?? {});

            const currentTaskId = data?.data?.id;
            const progress = data?.data?.result?.data_update_percent ?? 0;
            if (currentTaskId === taskId && Number(progress) === 100 && prevDataRef?.current?.data?.result?.data_update_percent !== progress) {
                refreshTableData();
                prevDataRef.current = data;
            }
        } else if (data?.message) {
            setInitialLoading(false);
        }
    }, [data]);

    const taskTypeLabel = (progressData?.type ?? progressData?.task_type) === "search_and_replace" ? "Search and Replace" : "Group Edit";
    const formatTaskDate = value => (value && moment(value).isValid() ? moment(value).format("MM-DD-YYYY hh:mm A") : "-");

    const isFailedTask = Number(progressData?.status) === 4 || progressData?.result?.success === false;
    const resultError = progressData?.result?.error;
    const errorMessage = isFailedTask
        ? (typeof resultError === "string" ? resultError : resultError?.detail || resultError?.message) || progressData?.result?.message || ""
        : "";

    const skippedCount = Number(progressData?.result?.skipped_count ?? 0);
    const skippedAssets = Array.isArray(progressData?.result?.skipped_assets) ? progressData.result.skipped_assets : [];

    return (
        <div
            className="modal modal-region modal-view modal-voice-view group-edit-progressbar"
            id="modalId"
            style={{ display: "block" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <Draggable handle=".draggable" cancel="close">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header draggable">
                            <h5 className="modal-title" id="exampleModalLabel">
                                <div className="txt-hed">{`${taskTypeLabel} Progress`}</div>
                            </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">
                                    <img src="/img/close.svg" alt="" />
                                </span>
                            </button>
                        </div>
                        <LoadingOverlay active={initialLoading} spinner={<Loader />} fadeSpeed={10}>
                            <div className="modal-body region-otr group-edit-progressbar-body">
                                <div className="dtl-sec system-building col-md-12 p-0">
                                    <div className="region-mng">
                                        <div className="tab-active location-sec recom-sec main-dtl p-0 build-dtl dtl-dy-set-outer progress-modal-inner">
                                            <div className="mb-3">
                                                <div className="col-md-12 p-0">
                                                    {progressData?.result?.total_count ? (
                                                        <div className="basic-otr p-0 d-flex progress-top-wrp">
                                                            <div className="rt-sec">
                                                                <div className="rt-blks">
                                                                    <div className="field-title">Type:</div>
                                                                    <span className="value-blk">{taskTypeLabel}</span>
                                                                </div>
                                                                <div className="rt-blks">
                                                                    <div className="field-title">Completed Count:</div>
                                                                    <span className="value-blk step-count">
                                                                        {progressData?.result?.total_count
                                                                            ? `${progressData?.result?.data_updated_count}/${progressData?.result?.total_count}`
                                                                            : "-"}
                                                                    </span>
                                                                </div>
                                                                <div className="rt-blks">
                                                                    <div className="field-title">Status:</div>
                                                                    <span
                                                                        className="value-blk status progress-completed"
                                                                        style={{
                                                                            color: progressStatus?.[progressData?.status]?.color ?? "#8193A9"
                                                                        }}
                                                                    >
                                                                        <span
                                                                            className="status-circle"
                                                                            style={{
                                                                                backgroundColor:
                                                                                    progressStatus?.[progressData?.status]?.color ?? "#8193A9"
                                                                            }}
                                                                        ></span>
                                                                        {progressStatus?.[progressData?.status]?.value}
                                                                    </span>{" "}
                                                                </div>
                                                                <div className="rt-blks">
                                                                    <div className="field-title">Started At:</div>
                                                                    <span className="value-blk">
                                                                        {formatTaskDate(progressData?.started_at ?? progressData?.result?.started_at)}
                                                                    </span>
                                                                </div>
                                                                <div className="rt-blks">
                                                                    <div className="field-title">Completed At:</div>
                                                                    <span className="value-blk">
                                                                        {formatTaskDate(progressData?.date_done ?? progressData?.result?.date_done)}
                                                                    </span>
                                                                </div>
                                                                <div className="rt-blks progress-wrp">
                                                                    <div className="field-title">
                                                                        Percentage ({progressData?.result?.data_update_percent ?? 0}%)
                                                                        <button
                                                                            className="btn btn-reset-fl-cmn mr-2 ml-2"
                                                                            type="button"
                                                                            onClick={refresh}
                                                                        >
                                                                            <span className="icon mr-1">
                                                                                <img src={refreshIcon} alt="refresh" />
                                                                            </span>
                                                                            <span className="text">Refresh Status</span>
                                                                        </button>
                                                                    </div>

                                                                    <ProgressBar now={progressData?.result?.data_update_percent ?? 0} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : errorMessage ? null : (
                                                        "No Data"
                                                    )}
                                                    {errorMessage ? (
                                                        <div className="task-error-wrp">
                                                            <div className="task-error-head">
                                                                <i className="fas fa-exclamation-circle icon" />
                                                                {`${taskTypeLabel} Failed`}
                                                            </div>
                                                            <div className="task-error-msg">{errorMessage}</div>
                                                        </div>
                                                    ) : null}
                                                    {skippedCount > 0 ? (
                                                        <div className="skipped-assets-wrp">
                                                            <div className="skipped-assets-head">
                                                                <img
                                                                    src="/img/info-orange.svg"
                                                                    alt="warning"
                                                                    width="16"
                                                                    height="16"
                                                                    className="icon"
                                                                />
                                                                <span>
                                                                    {progressData?.result?.skipped_message ??
                                                                        `${skippedCount} asset(s) were not updated.`}
                                                                </span>
                                                            </div>
                                                            {skippedAssets.length ? (
                                                                <div className="skipped-assets-table-otr">
                                                                    <table className="skipped-assets-table">
                                                                        <thead>
                                                                            <tr>
                                                                                <th className="asset-code-col">Asset Code</th>
                                                                                <th>Reason</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {skippedAssets.map((asset, index) => (
                                                                                <tr key={asset?.code ?? index}>
                                                                                    <td className="asset-code-col">{asset?.code ?? "-"}</td>
                                                                                    <td>{asset?.message}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    ) : null}
                                                    {progressData?.result?.total_count ? (
                                                        <div className="filter-head">
                                                            <span className="query-badge d-flex align-items-center">
                                                                <img src="/img/info-orange.svg" alt="warning" width="16" className="mr-2 icon" />
                                                                Note: Please refresh the table view after the edit is completed to see the latest
                                                                updates.
                                                            </span>
                                                        </div>
                                                    ) : null}
                                                    {canSeeTaskManager ? (
                                                        <div className="task-manager-track-wrp">
                                                            <button
                                                                type="button"
                                                                className="btn task-manager-track-btn"
                                                                onClick={() => setShowTaskManager(true)}
                                                            >
                                                                <i className="fas fa-tasks icon" />
                                                                Track progress in Task Manager
                                                            </button>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </LoadingOverlay>
                    </div>
                </div>
            </Draggable>
            {showTaskManager ? <TaskManagerModal onCancel={() => setShowTaskManager(false)} /> : null}
        </div>
    );
};

export default ProgressBarModal;
